export default "__VITE_ASSET__D9vj5kBR__"